import { FareType } from 'server-schemas/channels';
import type { FareTypeKey, FaresByType, FlightDetail } from 'server-schemas/search';

export const isStandardFareType = (type?: FareTypeKey) => {
  return type === 'PROMOTIONAL' || type === 'STANDARD';
};

export const getFareTypeKey = (flightFareType: FareType, fares: FaresByType): FareTypeKey => {
  if (flightFareType === FareType.Standard && fares.PROMOTIONAL) {
    return 'PROMOTIONAL';
  }
  return flightFareType == FareType.Flexi ? 'FLEXI' : 'STANDARD';
};

export const getStandardFareDetail = (fares: FaresByType | undefined) => {
  return fares?.PROMOTIONAL ?? fares?.STANDARD;
};

export const getWasFareDetail = (fares: FaresByType | undefined) => {
  return fares?.PROMOTIONAL ? fares?.STANDARD : undefined;
};

export const getNumberOfSeatsLeft = (flight: FlightDetail | undefined) => {
  return getStandardFareDetail(flight?.fares?.ADT)?.unitsAvailableAtThisPrice ?? 0;
};
